<template>
    <div style="width: 100%; min-height: 100vh; background: rgb(237, 241, 255)">
      <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7" :title="$langmsg.relc_title" left-arrow @click-left="$router.back()" />
      <div style="height: 46px"></div>
      <div class="usrse">
  
        <div class="hgs">
          <div class="nams">{{ $langmsg.relc_name }}</div>
          <div style="border-bottom: 1px solid #f2f2f2">
            <van-cell-group>
              <van-field v-model="relc_name" :readonly="relc_names" type="text" :placeholder="$langmsg.relc_name_tips" />
            </van-cell-group>
          </div>
        </div>
        <div class="hgs">
          <div class="nams">{{ $langmsg.relc_card }}</div>
          <div style="border-bottom: 1px solid #f2f2f2">
            <van-cell-group>
              <van-field v-model="relc_card" :readonly="relc_cards" type="text" :placeholder="$langmsg.relc_card_tips" />
            </van-cell-group>
          </div>
        </div>
        <van-button type="info" style="margin-top: 20px; width: 100%" v-if="$store.state.userInfo.realcheck == 'no'" @click="editPassword()">{{ $langmsg.success }}</van-button>
        <div style="height: 60px; color:red;">{{ $langmsg.relc_tips }}</div>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: 'password',
    data() {
      return {
        relc_name: null,
        relc_card: null,
        relc_names: false,
        relc_cards: false,
      };
    },
    created() {
      let that = this;
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      
      that.relc_name = userInfo.realname;
      if(that.relc_name){
        that.relc_names = true;
      }
      that.relc_card = userInfo.realcard;
      if(that.relc_card){
        that.relc_cards = true;
      }
    },
    methods: {
      changPsw(name) {
        this[name] = !this[name];
      },
      editPassword() {
        let that = this;

        let info = { realname: that.relc_name, realcard: that.relc_card,edit_rel:'yes' };

        if (!that.relc_name) {
          that.$parent.showTost(0,that.$parent.$langmsg.relc_ck_name);
          return;
        }
        if (!that.relc_card) {
          that.$parent.showTost(0,that.$parent.$langmsg.relc_ck_card);
          return;
        }
  
        that.$parent.showLoading();
        that.$apiFun.post('/api/updateuserinfo', info).then(res => {
          //console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0,res.message);
          }
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.realname = info.realname;
            userInfo.realcard = info.realcard;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$parent.getUserInfo();
            that.$parent.showTost(1,that.$parent.$langmsg.a_success);
          }
          that.$parent.hideLoading();
        }).catch(res=>{
          that.$parent.hideLoading();
        });
      },
    },
    mounted() {
      let that = this;
    },
    updated() {
      let that = this;
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .usrse {
    background: #fff;
    box-sizing: border-box;
    padding: 6px 20px 0;
    .nams {
      font-size: 0.38rem;
      color: #000;
      vertical-align: middle;
      margin-top: 10px;
      font-weight: 700;
    }
    .imgsa {
      position: relative;
      height: 2rem;
      border-bottom: 1px solid #f2f2f2;
      padding-bottom: 0.2rem;
      .bisn {
        width: 0.8rem;
        position: absolute;
        bottom: 0.3rem;
        left: 1.4rem;
      }
      img {
        width: 2rem;
        border-radius: 50%;
      }
    }
  }
  [class*='van-hairline']:after {
    border: none;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/relcard.vue